/* eslint-disable no-console */
import * as api from 'service/ConfigAPI';

import * as types from './types';
import { getActiveIntegrationObject } from './selectors';

/**
 * Enum Configurations Operating level
 * @enum {string} [company]
 */
export const Levels = {
  Company: 'Company',
  Warehouse: 'Warehouse',
  Pos: 'Pos',
  User: 'User',
};

/**
 * Enum Hardwar INTEGRATION_TYPES
 * @enum {string}
 */
export const IntegrationTypes = {
  payment: 'payment',
  scale: 'scale',
  printer: 'printer',
  customerDisplay: 'customerDisplay',
  cashDrawer: 'cashDrawer',
};

/**
 *  Get selected integrations for each integration type for a specific level
 * @param {Levels} level - Operating elvel - []
 * @param level_id - operating level ID
 * @returns {function(...[*]=)}
 */
export const fetchActiveIntegrationsPerLevel =
  ({ level, level_id }) =>
  async (dispatch) => {
    dispatch({ type: types.FETCH_ACTIVE_INTEGRATIONS.START });
    try {
      const { data } = await api.getConfiguration({
        level,
        level_id,
        name: 'active-integrations',
        type: 'integrations',
      });
      if (data.statusCode && data.statusCode === '500') {
        return dispatch({
          type: types.FETCH_ACTIVE_INTEGRATIONS.ERROR,
          payload: data.message,
        });
      }
      if (data.length) {
        return dispatch({
          type: types.FETCH_ACTIVE_INTEGRATIONS.SUCCESS,
          payload: data[0],
        });
      }
      return dispatch({
        type: types.FETCH_ACTIVE_INTEGRATIONS.SUCCESS,
        payload: {
          level,
          level_id,
          name: 'active-integrations',
          type: 'integrations',
        },
      });
    } catch (err) {
      console.error(err);
      return dispatch({
        type: types.SAVE_ACTIVE_INTEGRATIONS.ERROR,
        payload: err.message,
      });
    }
  };

/**
 * Save selected integration as default for the selected integration type
 * @param {IntegrationTypes} integrationType - type of the integration
 * @param {string} value - selected payment integration, example: 'adyen'
 * @returns {function(...[*]=)}
 */
export const saveActiveIntegration =
  ({ integrationType, value }) =>
  async (dispatch, getState) => {
    dispatch({ type: types.SAVE_ACTIVE_INTEGRATIONS.START });
    const activeIntegrationsConfig = getActiveIntegrationObject(getState());
    const params = {
      ...activeIntegrationsConfig,
      value: {
        ...activeIntegrationsConfig.value,
        [integrationType]: value,
      },
    };
    try {
      if (params.id) {
        await api.updateConfiguration(params);
      } else {
        await api.saveConfiguration(params);
      }
      dispatch({
        type: types.SAVE_ACTIVE_INTEGRATIONS.SUCCESS,
        payload: {
          ...activeIntegrationsConfig,
          value: {
            ...activeIntegrationsConfig.value,
            [integrationType]: value,
          },
        },
      });
    } catch (err) {
      console.error(err);
    }
  };
